@if (globalConfigurationService.getUseRootFilter() && isAllowed) {
    <div
        class="root-filter">
        <label tabindex="0" class="root-filter__checkbox-container" id="root-filter-first-answer"
               data-e2e="root-filter-select-junior"
               (keydown.enter)="selectOption(filterState.junior)"
               #labelContainer>
            <span class="root-filter__checkbox-label">Citizen Code Junior</span>
            <mat-icon class="root-filter__checkbox-icon"
                      svgIcon="logo_CTZC_junior"></mat-icon>
            <input class="root-filter__checkbox-input"
                   type="radio"
                   data-e2e="root-filter-junior"
                   [(ngModel)]="selectedOption"
                   [value]="filterState.junior"
                   (change)="update()"
                   #inputContainer>
        </label>
        <label tabindex="0" class="root-filter__checkbox-container" data-e2e="root-filter-select-explorer"
               (keydown.enter)="selectOption(filterState.explorer)" #labelContainer>
            <span class="root-filter__checkbox-label">Citizen Code Collège</span>
            <mat-icon class="root-filter__checkbox-icon"
                      svgIcon="logo_CTZC_college"></mat-icon>
            <input class="root-filter__checkbox-input"
                   type="radio"
                   data-e2e="root-filter-explorer"
                   [(ngModel)]="selectedOption"
                   [value]="filterState.explorer"
                   (change)="update()"
                   #inputContainer>
        </label>
        <label tabindex="0" class="root-filter__checkbox-container" data-e2e="root-filter-select-python"
               (keydown.enter)="selectOption(filterState.python)" #labelContainer>
            <span class="root-filter__checkbox-label">Citizen Code Python</span>
            <mat-icon class="root-filter__checkbox-icon"
                      svgIcon="logo_CTZC_python"></mat-icon>
            <input class="root-filter__checkbox-input"
                   type="radio"
                   data-e2e="root-filter-python"
                   [(ngModel)]="selectedOption"
                   [value]="filterState.python"
                   (change)="update()"
                   #inputContainer>
        </label>
        <label tabindex="0" class="root-filter__checkbox-container" data-e2e="root-filter-select-iakathon"
               (keydown.enter)="selectOption(filterState.iakathon)" #labelContainer>
            <span class="root-filter__checkbox-label">Citizen Code IAkathon</span>
            <mat-icon class="root-filter__checkbox-icon"
                      svgIcon="logo_CTZC_iakathon"></mat-icon>
            <input class="root-filter__checkbox-input"
                   type="radio"
                   data-e2e="root-filter-iakathon"
                   [(ngModel)]="selectedOption"
                   [value]="filterState.iakathon"
                   (change)="update()"
                   #inputContainer>
        </label>
    </div>
}
